/**
 * useItems Hook
 * Manages wishlist items with real-time updates
 */

import { useEffect, useState } from 'react'
import { WishlistItem } from '@/types'
import { subscribeToWishlistItems } from '@/services/item.service'

export function useItems(wishlistId: string | undefined) {
  const [items, setItems] = useState<WishlistItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!wishlistId) {
      setItems([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const unsubscribe = subscribeToWishlistItems(wishlistId, items => {
      setItems(items)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [wishlistId])

  // Group items by category
  const itemsByCategory = items.reduce(
    (acc, item) => {
      const categoryId = item.categoryId || 'uncategorized'
      if (!acc[categoryId]) {
        acc[categoryId] = []
      }
      acc[categoryId].push(item)
      return acc
    },
    {} as Record<string, WishlistItem[]>
  )

  return {
    items,
    itemsByCategory,
    loading,
    error,
  }
}
